"use client";
import { Icon } from "@iconify/react";
import "./style.css";

interface IProps {
  icon: string;
  label?: string;
  width?: number | string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const AppIcon = ({ icon, label, width = 15, className, style, onClick }: IProps) => {
  return (
    <div
      className={`app-icon ${className || ""}`}
      style={{ display: "inline-flex", alignItems: "center", ...style }}
      onClick={onClick}
    >
      <Icon icon={icon} width={width} />
      {label && (
        <span style={{ marginLeft: 6, display: "inline-block", verticalAlign: "middle" }}>
          {label}
        </span>
      )}
    </div>
  );
};

export default AppIcon;
